// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

// Components
import "./components";

// Plugins
import "./plugins";

// Sync router with store
import { sync } from "vuex-router-sync";

// Application imports
import App from "./App";
import i18n from "@/i18n";
import router from "@/router";
import store from "@/store";
import { auth } from "@/fireinit.js";
import VueSweetalert2 from "vue-sweetalert2";
import VueSilentbox from "vue-silentbox";
import "babel-polyfill";
import moment from "moment";
import "sweetalert2/dist/sweetalert2.min.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import VueApexCharts from "vue-apexcharts";
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";
import VueMeta from "vue-meta";

Vue.use(VueSweetalert2);
Vue.use(VueSilentbox);
Vue.use(VueMeta);
Vue.prototype.$clone = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};
Vue.use(TiptapVuetifyPlugin, {
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: "mdi",
});

Vue.filter("moneyWithComma", (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

Vue.prototype.$defaultText = (defaultText, object, property) => {
  if (typeof property !== "undefined") {
    if (object && object.hasOwnProperty(property)) {
      if (object[property] === null) return defaultText;
      return object[property] !== "" ? object[property] : defaultText;
    } else {
      return defaultText;
    }
  } else {
    return object && object !== "" ? object : defaultText;
  }
};

//MIXIN
Vue.mixin({
  methods: {
    calculateCommunityHrs(value) {
      if (value != "") {
        return Math.round(parseFloat(value / 22.75));
      } else {
        return "0";
      }
    },
  },
});

Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);

// Sync store with router
sync(store, router);

Vue.config.productionTip = false;
Vue.prototype.$moment = moment;
Vue.use(moment);

auth.onAuthStateChanged((user) => {
  /* eslint-disable no-new */
  new Vue({
    i18n,
    router,
    store,
    beforeCreate() {
      if (localStorage.getItem("type")) {
        this.$store.dispatch(
          "general/changeType",
          localStorage.getItem("type")
        );
      }

      this.$store.dispatch("axios/updateUrl", window.location.host);
      this.$store.dispatch("business/loadAll");
      this.$store.dispatch("impactBusinesses/loadAll");
      this.$store.dispatch("categories/loadAll");
      this.$store.dispatch("goodCauses/loadAll");
      if (user) {
        this.$store.commit("user/setUser", { auth: user });
        this.$store.dispatch("user/loadUserData");
        this.$store.dispatch("actionCenter/loadAll");
      }
    },
    render: (h) => h(App),
  }).$mount("#app");
});
